import React from "react";
import emptyBox from "../images/emptyBox.svg";

export default function NoData({text}){
    
    return (
        <div className="nodata">
            <img src={emptyBox} alt="상자" />
            <p className="text">{text}</p>
        </div>
    );
};